import { Link, Stack } from "@mui/material";
import type { Course, Store } from "../shared/web/schema/getStores";
import ClassNames from "../util/ClassNames";
import { ColorHexCodes } from "../util/Color";
import Time from "../util/Time";
import Breakable from "./Breakable";
import style from "./ReservationSummary.module.css";
import Space from "./Space";
import { StyledText } from "./StyledText";

export default function ReservationSummary({ data }: { data: { store: Store; nominated_staff: { id: number; name: string } | null; course: Course; date: number; name: string; phone: string; mail: string; request: string } }) {
  const addresses = [data.store.prefecture, data.store.address_1, data.store.address_2];
  const ds = new Time(data.date).DateStrings();
  return (
    <Stack style={{ gap: 10 }}>
      <StyledText textStyle="Bold">ご予約情報</StyledText>
      <InfoItem label="店舗" value={data.store.name} />
      <InfoItem hide={!data.store.nomination_enabled} label="スタッフ" value={data.nominated_staff?.name ?? "指名なし"} />
      <InfoItem label="メニュー" value={data.course.name} />
      <InfoItem label="日時" value={`${ds.year}年${ds.month}月${ds.date}(${ds.day}) ${ds.hour}時${ds.minute}分 (${data.course.duration / Time.AMinute}分間)`} />
      <div style={{ background: `#${ColorHexCodes.MainColorGreen}`, height: 1, width: "100%" }} />
      <div>
        <StyledText textStyle="Bold">店舗情報</StyledText>
        <div className={ClassNames(style.mapContainer)}>
          <Stack style={{ flexGrow: 2 }}>
            <Space h={15} />
            <InfoItem label="店舗" value={data.store.name} />
            <Space h={15} />
            <InfoItem label="TEL" value={data.store.phone} />
            <Space h={15} />
            <Stack direction={"row"}>
              <Stack style={{ width: 90 }}>
                <StyledText>住所</StyledText>
              </Stack>
              <Stack style={{ flexGrow: 1, width: 0 }}>
                <StyledText>{`〒${data.store.post_code}`}</StyledText>
                <Breakable style={{ overflowWrap: "anywhere" }} texts={addresses} />
              </Stack>
            </Stack>
            <Space h={15} />
            <Stack direction={"row"}>
              <Stack style={{ width: 90 }}>
                <StyledText>HP</StyledText>
              </Stack>
              <Link href={data.store.homepage} style={{ flexGrow: 1, width: 0, wordBreak: "break-all" }}>
                {data.store.homepage}
              </Link>
            </Stack>
          </Stack>
          <iframe src={`https://maps.google.co.jp/maps?q=${addresses.join()}&output=embed&t=m&z=16&hl=ja`} style={{ border: "none", flexGrow: 2, minHeight: "300px", minWidth: "300px" }} title="map" />
        </div>
      </div>
      <div style={{ background: `#${ColorHexCodes.MainColorGreen}`, height: 1, width: "100%" }} />
      <StyledText textStyle="Bold">お客様情報</StyledText>
      <InfoItem label="お名前" value={data.name} />
      <InfoItem label="TEL" value={data.phone} />
      <InfoItem label="E-MAIL" value={data.mail} />
      <InfoItem label="ご要望" value={data.request} />
    </Stack>
  );
}

function InfoItem({ label, value, hide }: { label: string; value: string; hide?: boolean }) {
  if (hide) {
    return null;
  }
  return (
    <Stack direction={"row"}>
      <Stack style={{ width: 90 }}>
        <StyledText>{label}</StyledText>
      </Stack>
      <Stack style={{ flexGrow: 1, width: 0 }}>
        <StyledText>{value}</StyledText>
      </Stack>
    </Stack>
  );
}
